import { call, delay, put, race } from "redux-saga/effects"
import jwtDecode from "jwt-decode"
import * as Cookies from "es-cookie"
import history from "govHistory"
import { refreshToken } from "apis/JWToken"
import setDcmRetUrl from "organisms/agreementSelection/setDcmRetUrl"
import { DLogin } from "apis/DLogin"
import { storeIsAuthLoading, storeIsAuthentication } from "actions"

// ASにリダイレクトしたりF5更新した場合に実行される
export function* execDAuthInitial() {
  const { pathname } = document.location

  try {
    // 初期表示の段階で SearchParams からサービス URL を取得しておく
    setDcmRetUrl()
    const cookieJwt = Cookies.get("JWToken")

    const { posts, timeout } = yield race({
      posts: call(getToken, cookieJwt),
      timeout: delay(5000),
    })

    if (timeout) {
      throw Error("timeout")
    }

    const { tokenRefreshError } = posts

    if (tokenRefreshError && tokenRefreshError.message === "invalid token") {
      yield call(DLogin, { prompt: false })
    } else if (
      tokenRefreshError &&
      tokenRefreshError.message === "dauth error"
    ) {
      yield call(history.push, "/error", { pathname })
    }
  } catch (e) {
    Cookies.remove("JWToken")
    const authentication = {
      isAuthentication: false,
      jwt: null,
    }
    yield put(storeIsAuthentication(authentication))
    return {
      tokenRefreshError: e,
      jwt: null,
    }
  } finally {
    yield put(storeIsAuthLoading(false))
  }
}

// アクセストークン有効期限を確認する
export function* getToken(jwt) {
  try {
    const { expireAt } = jwtDecode(jwt)
    const limitTime = new Date()
    limitTime.setSeconds(limitTime.getSeconds() + 10)
    // アクセストークン有効期限切れ（Expireの時間+10秒）の場合、トークンリフレッシュを行う
    if (expireAt < limitTime) {
      const { payload, error } = yield call(refreshToken, jwt)
      if (payload && !error) {
        // Authenticated!!
        Cookies.set("JWToken", payload.token, { secure: true })
        const authentication = {
          isAuthentication: true,
          jwt: payload.token,
        }
        yield put(storeIsAuthentication(authentication))
        return {
          jwt: payload.token,
        }
      }
      // トークンリフレッシュ失敗、またはdアカ側でエラー発生の場合
      throw Error(error.status === 401 ? "invalid token" : "dauth error")
    }
    // アクセストークン有効期限内の場合、リフレッシュの必要性なし
    const authentication = {
      isAuthentication: true,
      jwt,
    }
    yield put(storeIsAuthentication(authentication))
    return {
      jwt,
    }
  } catch (e) {
    // URL実行時にクッキーにJWTがない場合
    // トークンリフレッシュ失敗、またはdアカ側でエラー発生の場合
    Cookies.remove("JWToken")
    const authentication = {
      isAuthentication: false,
      jwt: null,
    }
    yield put(storeIsAuthentication(authentication))
    return {
      tokenRefreshError: e,
      jwt: null,
    }
  }
}
